
import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { RemoteFetchInputAcknowledgement } from "../../../data/usecases/user-input-acknowledgement/remote-fetch-user-acknowledgement";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { FetchInputAcknowledgementType } from "../../../domain/models/user-input-acknowledgement/user-input-acknowledgement-type";
import { FetchInputAcknowledgement } from "../../../domain/useages/user-input-acknowledgement/fetch-user-input-acknowledgement";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";

export interface FetchInputAcknowledgementSliceInterface {
  FetchInputAcknowledgement: FetchInputAcknowledgementType;
  FetchInputAcknowledgementState: FetchState;
  fetchInputAcknowledgement: Function;
}

const initialStates = {
  FetchInputAcknowledgement: {} as FetchInputAcknowledgementType,
  FetchInputAcknowledgementState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchInputAcknowledgementSlice: StateCreator<
  FetchInputAcknowledgementSliceInterface
> = (set) => ({
  ...initialStates,
  fetchInputAcknowledgement: async (filter: FetchInputAcknowledgement.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchInputAcknowledgement = new RemoteFetchInputAcknowledgement(
      `${BASE_URL}${Endpoints.FETCH_USER_INPUT_ACKNOWLEDGEMENT}`,

      axiosHttpClient
    );

    set(() => ({ FetchInputAcknowledgementState: FetchState.LOADING }));
    let result = await remoteFetchInputAcknowledgement.fetch(filter);
    return result;
  },
});
